import { render, staticRenderFns } from "./SendToFirmaDialogComponent.vue?vue&type=template&id=139581dd&lang=pug"
import script from "./SendToFirmaDialogComponent.vue?vue&type=script&lang=ts"
export * from "./SendToFirmaDialogComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139581dd')) {
      api.createRecord('139581dd', component.options)
    } else {
      api.reload('139581dd', component.options)
    }
    module.hot.accept("./SendToFirmaDialogComponent.vue?vue&type=template&id=139581dd&lang=pug", function () {
      api.rerender('139581dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/firma/SendToFirmaDialogComponent.vue"
export default component.exports